import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY, Observable } from 'rxjs';

import { ToastService } from '@app/services/toast.service';
import { LoadingService } from '@app/services/loading.service';
import { ApiService } from '@app/services/json-rest-api.service';
import { ApiMethod } from '@app/interfaces/api-request-body.interface';
import { ImportAddressesResponse } from '@app/interfaces/swiss-post-import.interface';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  loadingSrv = inject(LoadingService);
  toastSrv = inject(ToastService);
  restApi = inject(ApiService);

  uploadSwissAddresses(file: File): Observable<ImportAddressesResponse> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.loadingSrv.runWithLoading(
      this.restApi.post<ImportAddressesResponse>(ApiMethod.uploadSwissAddresses, formData).pipe(
        catchError((error) => {
          this.toastSrv.showToast('Error uploading Swiss addresses: ' + error.message);
          return EMPTY;
        }),
      ),
    );
  }
}
